import { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import {
  ArrowLeftRight,
  PlusCircle,
  ThreeDotsVertical,
} from "react-bootstrap-icons";
import { SubmitHandler, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import FormSelect from "../../../Components/FormTag/FormSelect";
import InputFiled from "../../../Components/FormTag/InputFiled";
import OffCanvas from "../../../Components/FormTag/OffCanvas";
import { Column } from "../../../Components/Tables/Table";
import { asnDate, eta } from "../../../Data/dropdownDataList";
import { TabConfig } from "../../../model/common/tabs";
import { ALPHANUM_SPACE_REGEX } from "../../../Shared/Helper/Constant";
import { PATTERN_ERR_MSG } from "../../../Shared/Helper/ValidationMessage";
import { formatNumber,prepareSearchColumns } from "../../../Utility/Utility";
import { asnAdvanceFilter } from "../Check-In/CheckIn.type";
import AsnList from "../List/AsnList";
import { CustomReceive } from "../model/receiveOverview.model";
import { useSearchStore } from "../../../store/search/searchStore";
import Loader from "../../../Components/GlobalLoader/Loader";
import useWarehouseStore from "../../../store/warehouse/useWarehouseStore";
import useClientStore from "../../../store/client/useClientStore";

export default function ReceiveOverview() {
  const pageName = "Receive";
  const addUrl = "/inbound/asn/receive/create";
  const listUrl = "/inbound/asn/receive";
  const buttonStatus = true;
  const [isShowCanvas, setShowCanvas] = useState(false);
  const [loading, setLoading] = useState(true);
  const { searchTerm, resetSearch, previousSearchTerm, setPreviousTerm } =
  useSearchStore();
  const [warehouseId, setWarehouseId] = useState<any>(null);
  const [clientId, setClientId] = useState<any>(null);
  const navigation = useNavigate();
  const { getSelectedWarehouse } = useWarehouseStore();
  const { getSelectedClient } = useClientStore();

  const [asnAdvanceFilterData, setAsnAdvanceFilterData] =
    useState<asnAdvanceFilter>(new asnAdvanceFilter());
  const {
    handleSubmit,
    register,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<asnAdvanceFilter>({
    defaultValues: asnAdvanceFilterData,
  });
  const nextData: SubmitHandler<asnAdvanceFilter> = (data) => {
    setAsnAdvanceFilterData(data);
    handleGlobalFilter();
  };
  const handleGlobalFilter = () => {
    setShowCanvas(!isShowCanvas);
  };

  const handelDetailAction = (id: any) => {
    return navigation(`/inbound/asn/receive/details/${id}`);
  };
  useEffect(() => {
    resetSearch();
    setLoading(false);
  }, [])
  useEffect(() => {
    const subscriptionWarehouse = getSelectedWarehouse().subscribe((warehouse) => {
      setWarehouseId(warehouse?.id);
    });
    const subscriptionClient = getSelectedClient().subscribe((client) => {
      setClientId(client?.id);
    });

    return () => {
      subscriptionWarehouse.unsubscribe();
      subscriptionClient.unsubscribe();
    };
  }, [getSelectedWarehouse, getSelectedClient]);

  const canvasHeader = (
    <>
      <div className="d-flex align-items-center gap-1">
        <Dropdown>
          <Dropdown.Toggle
            className="btn bg-white text-dark dropdown-toggle"
            id="dropdown-basic"
          >
            Saved Filter
          </Dropdown.Toggle>

          <Dropdown.Menu>
            <Dropdown.Item href="#/action-1" className="dropdown-toggle-item">
              One line count
            </Dropdown.Item>
            <Dropdown.Item href="#/action-2" className="dropdown-toggle-item">
              Special count
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
  const db_columns = [
    {
      data: "inbound_shipment.id",
    },
    {
      data: "inbound_shipment.shipment_number",
    },
    {
      data: "supplier.name as supplier_name",
    },
    {
      data: "inbound_shipment.tracking_number",
    },
    {
      data: "no_of_lines",
    },
    {
      data: "unload_warehouse_location.name as location",
    },
    // {
    //   data: "inbound_shipment.status",
    // }
  ];
  const exclude_columns = ["no_of_lines"];
  const search_columns = prepareSearchColumns(db_columns, exclude_columns);
  const columns: Column[] = [
    {
      name: "ASN #",
      column_name: "inbound_shipment.id",
      enableSorting: true,
      selector: (row: CustomReceive) => (
        <span
          className="cursor-pointer text-primary"
          onClick={() => handleRowClick(row.id)}
        >
          {row?.id ?? "-"}
        </span>
      ),
    },
    {
      name: "Supplier ",
      column_name: "supplier.name",
      selector: (row: CustomReceive) => <>{row?.supplier_name ?? "-"}</>,
    },

    {
      name: "Tracking",
      column_name: "inbound_shipment.tracking_number",
      selector: (row: CustomReceive) => (
        <>{formatNumber(row.tracking_number) ?? "-"}</>
      ),
    },
    {
      name: "Location",
      column_name: "unload_warehouse_location.name",
      selector: (row: CustomReceive) => <>{row?.location ?? "-"}</>,
    },
    {
      name: (
        <>
          <ArrowLeftRight /> <PlusCircle />
        </>
      ),
      selector: (row: any) => (
        <>
          <span
            className="cursor-pointer dropdown-toggle action-menu border-none"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <ThreeDotsVertical />
          </span>
          <ul className="dropdown-menu action-items px-0 py-1 vertical-menu-width">
            <li
              className="cursor-pointer ms-3 my-1 fs-14 fw-bold"
              onClick={() => handelDetailAction(row?.id)}
            >
              View
            </li>
          </ul>
        </>
      ),
    },
  ];

  const pageTabs: TabConfig[] = [
    {
      order: 0,
      name: "new",
      tabLable: "Ready To Receive",
      visibility: true,
      status: true,
      multiSelect: false,
    },
    {
      order: 1,
      name: "in progress",
      tabLable: "Receive In Progress",
      visibility: true,
      status: false,
      multiSelect: false,
    },
    {
      order: 2,
      name: "complete",
      tabLable: "Receive Completed",
      visibility: true,
      status: true,
      multiSelect: null,
    },
  ];

  const handleRowClick = (id: number) => {
    navigation(`/inbound/asn/receive/details/${id}`);
  };

  const Offcanvas = (
    <OffCanvas
      show={isShowCanvas}
      handleClose={handleGlobalFilter}
      title="Advance Filter"
      headerChildren={canvasHeader}
    >
      <>
        <div className="offcanvas-body offcanvas-height custom-scrollbar">
          <form>
            <div className="">
              <div>
                <label>ASN Date</label>
                <div>
                  <FormSelect
                    tabIndex={1}
                    name="asnDate"
                    control={control}
                    optionList={asnDate}
                    className="form-control p-0"
                    placeholder="Select"
                    isSearchable={true}
                  />
                </div>
              </div>
              <div className="my-3">
                <label>Supplier</label>
                <div>
                  <InputFiled
                    tabIndex={2}
                    type="text"
                    register={register}
                    name="supplier"
                    errors={errors.supplier}
                    className="form-control"
                    placeholder="Enter supplier"
                    pattern={{
                      type: ALPHANUM_SPACE_REGEX,
                      message: PATTERN_ERR_MSG,
                    }}
                  />
                </div>
              </div>
              <div>
                <label>ETA</label>
                <div>
                  <FormSelect
                    tabIndex={1}
                    name="eta"
                    control={control}
                    optionList={eta}
                    className="form-control p-0"
                    placeholder="Select"
                    isSearchable={true}
                  />
                </div>
              </div>
            </div>
          </form>
        </div>
        <div className="offcanvs-footer d-flex justify-content-end  px-0 border-top pt-3">
          <button
            className="btn offcanvas-close-btn px-4 mx-2 "
            onClick={handleGlobalFilter}
          >
            Clear
          </button>
          <button
            className="btn offcanvas-apply-btn px-4 px-2 "
            onClick={handleSubmit(nextData)}
          >
            Apply
          </button>
        </div>
      </>
    </OffCanvas>
  );
  return !loading ?(
    <AsnList
      db_columns={db_columns}
      search_columns={search_columns}
      columns={columns}
      pageName={pageName}
      addUrl={addUrl}
      listUrl={listUrl}
      pageTabs={pageTabs}
      Offcanvas={Offcanvas}
      handleGlobalFilter={handleGlobalFilter}
      buttonStatus={buttonStatus}
      isCreateBtnDisable={true}
      tableMultiSelect={false}
      warehouseId={warehouseId}
      clientId={clientId}
    />
  ):<Loader/>;
}
